import { render, staticRenderFns } from "./SectionChooser.vue?vue&type=template&id=40e11e3d"
import script from "./SectionChooser.vue?vue&type=script&lang=js"
export * from "./SectionChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports